"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M11 19h2v3h-2zm-9-8h3v2H2zm17 0h3v2h-3zm-3.1057 6.8014 1.4071-1.4071 2.1214 2.1213-1.4072 1.4072zm-11.31.7072 2.1213-2.1214 1.4072 1.4072-2.1214 2.1213zM15 8.02V3H9v5.02c-1.21.92-2 2.35-2 3.98 0 2.76 2.24 5 5 5s5-2.24 5-5c0-1.63-.79-3.06-2-3.98M11 5h2v2.1c-.32-.06-.66-.1-1-.1s-.68.04-1 .1z"
}), 'Tungsten');